import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { EmailAccountCreate } from "../../Partials/Dialog/EmailAccountCreate";
import { EmailAccountUpdate } from "../../Partials/Dialog/EmailAccountUpdate";
import { EmailAccountInterface } from "../../../Entity/Entities/EmailAccount/EmailAccountInterface";
import { User } from "../../../Entity/Entities/Person/Role/Roles/User";
import { TableComponent } from "../../Partials/Table/TableComponent";
// import { SubscriptionIcon } from "../../Partials/Subscription/SubscriptionIcon";
import { connect } from "react-redux";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

class EmailAccounts extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_CLEAR;
  protected selectedEmailAccount: EmailAccountInterface;

  private emailAccountToUpdate: EmailAccountInterface;
  protected emailAccountCreate = null;
  protected emailAccountUpdate = null;

  public state = {
    anchorEl: null
  }

  constructor(public props) {
    super(props);

    this.escFunction = this.escFunction.bind(this);
  }

  componentDidMount(){
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false);
  }

  public createAccount = (): void => {
    this.openDialog();
  }

  escFunction(event){
    if(event.keyCode === 27) {
      this.closeDialog();
    }
  }

  public openDialog = () => {
    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_DIALOG,
      payload: {
        isDialogOpen: true
      }
    });
  }

  public closeDialog = () => {
    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_DIALOG,
      payload: {
        isDialogOpen: false,
        isUpdating: false
      }
    });
  }

  // public getStarIcon(emailAccount: EmailAccountInterface): any {
  //   if (emailAccount.isAgencyAccount() === false && this.props.app.session.user.id === emailAccount.person.id) {
  //     return null;
  //   }

  //   return <SubscriptionIcon entity={emailAccount} {...this.props} />;
  // }

  protected openMenu = (event: any, emailAccount: EmailAccountInterface): void => {
    this.selectedEmailAccount = emailAccount;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public getMails = (filterAgencyAccounts: boolean, filterMyAccount: boolean = false, type: string) => {
    let emailAccounts: EmailAccountInterface[] = this.props.app.emailAccounts.filter(emailAccount => {
      return emailAccount.removed === false;
    });
    let isMyAccount: boolean = false;

    if (filterAgencyAccounts === true) {
      emailAccounts = emailAccounts
      .filter((emailAccount: EmailAccountInterface) => {
        return emailAccount.isAgencyAccount() === filterAgencyAccounts;
      });
    } else if (filterMyAccount === true) {
      emailAccounts = emailAccounts
      .filter((emailAccount: EmailAccountInterface) => {
        return emailAccount.isAgencyAccount() === false;
      })
      .filter((emailAccount: EmailAccountInterface) => {
        return (emailAccount.person && emailAccount.person.id === this.props.app.session.user.id) && emailAccount.imapUser === this.props.app.session.user.email;
      });
      isMyAccount = true;
    } else {
      emailAccounts = emailAccounts
      .filter((emailAccount: EmailAccountInterface) => {
        return emailAccount.isAgencyAccount() === false;
      })
      .filter((emailAccount: EmailAccountInterface) => {
        return emailAccount.person && emailAccount.person.id !== this.props.app.session.user.id;
      });
    }

    return emailAccounts.map((emailAccount: EmailAccountInterface) => {
      if (!emailAccount) {
        return;
      }
      return (
        <TableRow
          hover
          key={emailAccount.id}
          className={`clickable-entity entityId-${emailAccount.id}`}
          onClick={() => {
            if (!this.isUser() || isMyAccount) {
              this.updateEmailAccount(emailAccount);
            } else {
              this.props.dispatch({
                type: Constants.SNACKBAR_ADD_MESSAGE,
                payload: {
                  message: this.trans("preprocess/cantcreateactivitytemplate-info"),
                  type: "warning"
                }
              });
            }
          }}
        >
          {/* <TableCell>
            {this.getStarIcon(emailAccount)}
          </TableCell> */}
          <TableCell>
            {emailAccount.renderPrioritizedAvatar()}
          </TableCell>
          <TableCell style={{width: "40%"}}>
            {emailAccount.isAgencyAccount() === true && emailAccount.agency.displayName}
            {emailAccount.isAgencyAccount() === false && emailAccount.person.displayName}
          </TableCell>
          <TableCell style={{width: "45%"}}>{emailAccount.imapUser}</TableCell>
          <TableCell style={{width: "15%"}}>
            {emailAccount.active === true ? this.trans("active") : this.trans("inactive")}
          </TableCell>
          <TableCell
            style={{minWidth: "48px"}}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            {(type !== "MyEmail") && (
              <div style={{width: "48px"}}>
                <IconButton
                  onClick={e => this.openMenu(e, emailAccount)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.selectedEmailAccount && this.selectedEmailAccount.id === emailAccount.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  {/* {
                    !!this.selectedEmailAccount && type !== "AgencyEmail" && (
                      <MenuItem
                        leftIcon={<div className="icon icon-ic-edit"></div>}
                        primaryText={this.trans("edit")}
                        onClick={() => {
                          if (canSeeDropdown) {
                            this.updateEmailAccount(this.selectedEmailAccount);
                          } else {
                            this.props.dispatch({
                              type: Constants.SNACKBAR_ADD_MESSAGE,
                              payload: {
                                message: this.trans("preprocess/cantcreateactivitytemplate-info"),
                                type: "warning"
                              }
                            });
                          }
                        }}
                      />
                    )
                  } */}

                  {
                    !!this.selectedEmailAccount && emailAccount.active && (
                      <MenuItem
                        className="inactive-action"
                        onClick={() => {
                          if (!this.isUser()) {
                            this.inActiveEmailAccount(this.selectedEmailAccount);
                          } else {
                            this.props.dispatch({
                              type: Constants.SNACKBAR_ADD_MESSAGE,
                              payload: {
                                message: this.trans("preprocess/cantcreateactivitytemplate-info"),
                                type: "warning"
                              }
                            });
                          }
                        }}
                      >
                        <ListItemIcon><div className="icon icon-ic-close"></div></ListItemIcon>
                        <ListItemText>{this.trans("inactive")}</ListItemText>
                      </MenuItem>
                    )
                  }

                  {
                    !!this.selectedEmailAccount && (type === "AgencyEmail" || type === "UserEmail") && (
                      <MenuItem
                        className="delete-action"
                        onClick={() => {
                          if (!this.isUser()) {
                            this.deleteEmailAccount(this.selectedEmailAccount);
                          } else {
                            this.props.dispatch({
                              type: Constants.SNACKBAR_ADD_MESSAGE,
                              payload: {
                                message: this.trans("preprocess/cantcreateactivitytemplate-info"),
                                type: "warning"
                              }
                            });
                          }
                        }}
                      >
                        <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                        <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                      </MenuItem>
                    )
                  }
                </Menu>
              </div>
            )}
          </TableCell>
        </TableRow>
      );
    });
  }

  public addEmailAccount = (imapCredentials): any => {
    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_START,
      payload: {
        imapCredentials: imapCredentials
      },
      onSuccess: () => {
        this.emailAccountCreate.setState({
          isFetching: false
        });
      },
      onError: err => {
        this.emailAccountCreate.setState({
          isFetching: false,
          errors: err.fields.length === 0 ? [err.message, ...this.emailAccountCreate.state.errors] : [...this.emailAccountCreate.state.errors]
        });
      }
    });
  }

  public updateEmailAccount = (emailAccount: EmailAccountInterface): any => {
    this.closeMenu();

    this.emailAccountToUpdate = emailAccount;
    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_UPDATING,
      payload: {
        isUpdating: true
      }
    });
    this.openDialog();
  }

  public saveEmailAccount = (data: any): any => {
    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_START,
      payload: {
        emailAccount: data.emailAccount,
        imapCredentials: data.imapCredentials
      },
      onSuccess: () => {
        this.emailAccountUpdate.setState({
          isFetching: false
        });
      },
      onError: err => {
        this.emailAccountUpdate.setState({
          isFetching: false,
          errors: err.fields.length === 0 ? [err.message, ...this.emailAccountUpdate.state.errors] : [...this.emailAccountUpdate.state.errors]
        });
      }
    });
  }

  public deleteEmailAccount = (emailAccount: EmailAccountInterface): any => {
    this.closeMenu();

    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_START,
      payload: {
        emailAccount: emailAccount
      }
      ,
      onSuccess: () => {
        sessionStorage.removeItem('value-email-account')
      }

    });
  }

  public inActiveEmailAccount = (emailAccount: any): any => {
    this.closeMenu();

    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_INACTIVE_START,
      payload: {
        emailAccount: emailAccount.id
      }
    });
  }

  public isUser = (): boolean =>  {
    return this.props.app.session && this.props.app.session.user && this.props.app.session.user.role && this.props.app.session.user.role.getRoleId() === User.contactRoleId;
  }

  public getDialogContent = (): any => {
    if (this.props.component.isUpdating === true) {
      return (
        <EmailAccountUpdate
          {...this.props}
          ref={ref => this.emailAccountUpdate = ref}
          emailAccount={this.emailAccountToUpdate}
          onSave={this.saveEmailAccount}
          onCancel={this.closeDialog}
        />
      );
    }

    return (
      <EmailAccountCreate
        {...this.props}
        ref={ref => this.emailAccountCreate = ref}
        onSave={this.addEmailAccount}
        onCancel={this.closeDialog}
      />
    );
  }

  public getDialogTitle = (): string => {
    if (this.props.component.isUpdating === true) {
      return this.trans("update-email-account");
    }

    return this.trans("add-email-account");
  }

  public render() {
    return (
      <div style={{width: "100%"}}>
        <div className="component-wrapper no-margin-top no-margin-right">
          <Card className="card no-padding">
            <div className="label-container">
              <h3 className="card-title">
                {this.trans("my-email-account")}
              </h3>
            </div>
            <div>
              <TableComponent
                {...this.props}
                entities={this.props.app.emailAccounts}
                className="listing-table"
                subtitle={this.trans("no-emails-to-list")}
                rows={this.getMails(false, true, "MyEmail")}
                //onCellClick={this.updateEmailAccount}
              />
            </div>
          </Card>
        </div>

        <div className="component-wrapper no-margin-right">
          <Card className="card no-padding">
            <div className="label-container">
              <h3 className="card-title">
                {this.trans("user-email-accounts")}
              </h3>
            </div>
            <div>
              <TableComponent
                {...this.props}
                entities={this.props.app.emailAccounts}
                className="listing-table"
                subtitle={this.trans("setting-page-no-user-emails-to-list")}
                rows={this.getMails(false, false, "UserEmail")}
                //onCellClick={this.updateEmailAccount}
              />
            </div>
          </Card>
        </div>

        <div className="component-wrapper no-margin-right">
          <Card className="card no-padding">
            <div className="label-container">
              <h3 className="card-title">
                {this.trans("agency-email-accounts")}
              </h3>
              <Button
                color="primary"
                onClick={this.isUser() ? 
                  () => {
                    this.props.dispatch({
                      type: Constants.SNACKBAR_ADD_MESSAGE,
                      payload: {
                        message: this.trans("preprocess/cantcreateactivitytemplate-info"),
                        type: "warning"
                      }
                    });
                  } : 
                  this.createAccount}
              >
                {this.trans("add-email-account")}
              </Button>
            </div>
            <div>
              <TableComponent
                {...this.props}
                entities={this.props.app.emailAccounts}
                className="listing-table aling-left-first-child"
                subtitle={this.trans("no-emails-to-list")}
                rows={this.getMails(true, false, "AgencyEmail" )}
                //onCellClick={this.updateEmailAccount}
                ignoreFirstCellClick={true}
              />
            </div>
          </Card>
        </div>

        <PromptDialog
          {...this.props}
          title={this.getDialogTitle()}
          content={this.getDialogContent()}
          openLeavePrompt={this.props.component.isDialogOpen}
          onClose={this.closeDialog}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.emailAccounts,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  EmailAccounts
);
